import { type IResourceApiContext } from './common'
import { CurrentUserApi } from './current-user'
import { ExperienceApi } from './experience'
import { GeneratedCampaignApi } from './generated/campaigns'
import { GeneratedDistributionApi } from './generated/distributions'
import { ActivationApi } from './overrides/activations'

export class ExperienceResourceApi {
  distributions: GeneratedDistributionApi
  currentUser: CurrentUserApi
  #ctx: IResourceApiContext
  campaigns: GeneratedCampaignApi
  activations: ActivationApi
  experience: ExperienceApi

  constructor (ctx: IResourceApiContext) {
    this.#ctx = ctx
    this.distributions = new GeneratedDistributionApi(this.#ctx)
    this.activations = new ActivationApi(this.#ctx)
    this.campaigns = new GeneratedCampaignApi(this.#ctx)
    this.currentUser = new CurrentUserApi(this.#ctx)
    this.experience = new ExperienceApi(this.#ctx)
  }

  destroy (): void {
    // TODO cleanup? logout?
  }
}
